// @ts-nocheck
import { put, takeLatest } from 'redux-saga/effects';
import { getAPIDataV3 } from 'utils/api';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import { REQUESTS } from 'utils/services/thetaretail/requests';

function* handleDashBoardData() {
	try {
		yield put(
			slice.toggleLoader({
				loaderComponent: 'dashboard',
				isLoading: true,
			})
		);

		const response = yield getAPIDataV3({
			...REQUESTS.GET.GET_DASHBOARD_DATA,
		});
		const data = response?.data?.data || null;

		yield put(slice.updateDashboardData({ data }));
	} catch (error) {
		yield put(
			triggerNotification({
				message: error.message || 'An error occurred while fetching settings, please try again later',
			})
		);
	} finally {
		yield put(
			slice.toggleLoader({
				loaderComponent: 'dashboard',
				isLoading: false,
			})
		);
	}
}

export default function* rootSaga() {
	return [yield takeLatest(sagaActions.getDashBoardData, handleDashBoardData)];
}
